import React, { useState, useEffect } from 'react';
import { useNavigate } from "react-router-dom";
import URL from "../../../../constants/url";
import style from './MembershipComplete.module.css';
import imgComplete from '../../../../images/common/i_complete.svg';


const MembershipComplete = () => {

    const navigate = useNavigate();

    return (
        <>

            <div id="sub-content" data-layout="white">
                <div className='inner-wrap' data-padding="30">

                    <div className={style['mid-box']}>
                        <div className='animation-2'>
                            <p className={style['top']}>
                                <b>회원가입</b>이 <br />
                                <b>완료</b>되었습니다
                            </p>
                            <div className={style['mid']}>
                                <object data={imgComplete} alt="" aria-hidden='true' />
                            </div>
                        </div>
                    </div>


                    {/* 하단 다음 버튼 영역 :: S */}
                    <div className="bottom-fixed-box">
                        <div className="inner-box">
                            <div className='btn-layout' data-btn-num="1">

                                <button className="btn" data-btn-type="fill-main" data-btn-size="lg"
                                        onClick={() => navigate(URL.ACTIVITY_LEVEL_SELECT)}>
                                    <span>완료</span>
                                </button>

                            </div>
                        </div>
                    </div>
                    {/* 하단 다음 버튼 영역 :: E */}

                </div>
            </div>

        </>
    )
}

export default MembershipComplete
